module.exports = __webpack_public_path__ + "static/media/call-to-action-dark-blue-bokeh.96c2ed8b.jpg";